var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCongratsKeto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "k-logo-alert-icon-a",
    x1: "0%",
    x2: "100%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#264653"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "43.971%",
    stopColor: "#2A9D8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E9C46A"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "k-logo-alert-icon-b",
    points: "0 0 17.733 0 17.733 20.308 0 20.308"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "k-logo-alert-icon-d",
    points: ".44 .258 9.546 .258 9.546 9.365 .44 9.365"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "url(#k-logo-alert-icon-a)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.462 13.846)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "k-logo-alert-icon-c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k-logo-alert-icon-b"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M16.6608462,0.965215385 L12.1202308,6.8646 L17.6979231,19.3782923 C17.7334615,19.4138308 17.7334615,19.4853692 17.7334615,19.5569077 C17.7334615,19.9501385 17.3402308,20.3078308 16.8039231,20.3078308 L13.2643846,20.3078308 C12.7280769,20.3078308 12.2277692,19.8070615 12.0486923,19.3782923 L8.54515385,11.5482923 L5.25576923,15.8387538 L5.25576923,19.3782923 C5.25576923,19.8426 4.96961538,20.3078308 4.36176923,20.3078308 L0.929769231,20.3078308 C0.393,20.3078308 0.000230769231,19.8426 0.000230769231,19.3782923 L0.000230769231,0.965215385 C0.000230769231,0.428907692 0.393,0.000138461538 0.929769231,0.000138461538 L4.36176923,0.000138461538 C4.96961538,0.000138461538 5.25576923,0.428907692 5.25576923,0.965215385 L5.25576923,7.97275385 L10.6899231,0.965215385 C10.9760769,0.535984615 11.5123846,0.000138461538 12.2633077,0.000138461538 L15.7668462,0.000138461538 C16.3746923,0.000138461538 16.6608462,0.428907692 16.6608462,0.965215385",
    mask: "url(#k-logo-alert-icon-c)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.077 3.692)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "k-logo-alert-icon-e",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k-logo-alert-icon-d"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M7.44766154,3.67292308 L4.70612308,6.91523077 C4.57366154,7.07169231 4.38027692,7.16769231 4.17581538,7.17923077 L4.1352,7.18015385 C3.94273846,7.18015385 3.75996923,7.10723077 3.62012308,6.97476923 L2.59504615,6.00184615 C2.29643077,5.718 2.28396923,5.24353846 2.56735385,4.94446154 C2.85166154,4.64538462 3.32612308,4.63338462 3.62473846,4.91676923 L4.07566154,5.34507692 L6.30581538,2.70738462 C6.43412308,2.55507692 6.61504615,2.46184615 6.81396923,2.44523077 C7.01381538,2.42907692 7.20673846,2.49 7.35950769,2.61923077 C7.67427692,2.88553846 7.71396923,3.35815385 7.44766154,3.67292308 M4.9932,0.258 C2.47873846,0.258 0.440123077,2.29661538 0.440123077,4.81107692 C0.440123077,7.326 2.47873846,9.36461538 4.9932,9.36461538 C7.50812308,9.36461538 9.54673846,7.326 9.54673846,4.81107692 C9.54673846,2.29661538 7.50812308,0.258 4.9932,0.258",
    mask: "url(#k-logo-alert-icon-e)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCongratsKeto);
export default __webpack_public_path__ + "static/media/congratsKeto.fa6b300c.svg";
export { ForwardRef as ReactComponent };